/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const KeyIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="5.77083333" cy="18.2291667" r="1.4375" />
      <path d="M20.1458333,0.979166667 L10.7714167,10.3545417 C8.24525,9.04641667 5.062625,9.449875 2.94375,11.56875 C0.323666667,14.187875 0.323666667,18.4352083 2.94375,21.0552917 C5.56383333,23.675375 9.81116667,23.675375 12.4302917,21.0552917 C14.5482083,18.9364167 14.952625,15.75475 13.6454583,13.2295417 L16.7916667,10.0833333 L18.2291667,10.0833333 L18.2291667,8.64583333 L18.7083333,8.16666667 L20.1458333,8.16666667 L20.1458333,6.72916667 L20.625,6.25 L22.0625,6.25 L22.0625,4.8125 L23.0208333,3.85416667 L23.0208333,0.979166667 L20.1458333,0.979166667 Z" />
    </g>
  </svg>
);

export default KeyIcon;
